<template>
     <div class="product-progress my-2">
            <p class="progress-content">{{ progressContent }}</p>
            <div class="progress" :style="{ backgroundColor: progressBarBgColor }">
                <div class="progress-bar" :style="{ width: progress , backgroundColor: progressBarColor }"></div>
            </div>
            <!-- <div class="progress-percent">{{ progress }}</div> -->
        </div>
</template>

<script>
    export default {
        props: ['sold', 'qty'],

        computed: {
            progress() {
                if (typeof this.qty === 'undefined') {
                    return Math.floor(this.sold) + '%';
                }

                if (this.qty === null || this.sold === 0) {
                    return '0%';
                }

                return Math.floor(this.sold / (this.sold + this.qty) * 100) + '%';
            },

            progressBarColor() {
                const progressValue = parseInt(this.progress);
                if (progressValue < 20) {
                    return '#149a47'; 
                } else if (progressValue < 80) {
                    return '#feba12'; 
                } else {
                    return '#eb4435';
                }
            },
            progressContent() {
                const progressValue = parseInt(this.progress);
                if (progressValue < 20) {
                    return this.$trans('ecommerce::product_card.just_opened'); 
                } else if (progressValue < 80) {
                    return this.$trans('ecommerce::product_card.sold') + this.sold; 
                } else {
                    return this.$trans('ecommerce::product_card.out_of_stock');
                }
            },
            progressBarBgColor() {
                const progressValue = parseInt(this.progress);
                if (progressValue < 20) {
                    return '#149a474d'; 
                } else if (progressValue < 80) {
                    return '#feba124d'; 
                } else {
                    return '#eb44354d';
                }
            },
        },
    };
</script>
